module.exports = "/assets/smile@3x.png?YPeb/9/";